var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inv-popup"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"no btn",on:{"click":_vm.onReject}},[_vm._v("不接受")]),_c('div',{staticClass:"yes btn",on:{"click":_vm.onAccept}},[_vm._v("接受邀请")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }